
import { questions } from "../../ts/db-questions";
import { Advisor, advisors } from "../../ts/advisor";
import { StoredAnswer } from "@/db/ts/storedAnswer";
import { formatter } from "@/shared/ts/formatter";

export default {
  name: "GuiideAdvisors",
  emits: ["show-retirement-advisors-required"],
  props: {
    showYesOutcome: { default: false, required: true },
  },
  computed: {
    applicableAdvisors: function (): Array<Advisor> {
      const transferValue = this.getTransferValue();
      const applicableAdvisors = new Array<Advisor>();
      const showTransferAdvisors: boolean = this.showYesOutcome;
      const filterOnName = this.$store.state.configuration.filterAdvisors;

      if (filterOnName) {
        const filterString = this.$store.state.configuration.advisorFilter;
        advisors.all
          .filter((a) => a.contact.search(filterString) !== -1)
          .forEach((advisor) => {
            applicableAdvisors.push(advisor);
          });
      } else {
        let advisorsOfCorrectType: Array<Advisor>;

        if (showTransferAdvisors) {
          advisorsOfCorrectType = advisors.all.filter(
            (a) => a.isTransferAdvisor && transferValue >= a.minTransferValue
          );
        } else {
          advisorsOfCorrectType = advisors.all.filter(
            (a) => a.isGeneralAdvisor
          );
        }

        const dontPresentLowerPriorityAdvisors =
          advisorsOfCorrectType.length > 3;
        advisorsOfCorrectType.forEach((a) => {
          if (dontPresentLowerPriorityAdvisors && a.lowerPriority) {
            return;
          }
          applicableAdvisors.push(a);
        });
      }

      this.shuffleArray(applicableAdvisors);
      return applicableAdvisors;
    },
    storedAnswers(): Array<StoredAnswer> {
      return this.$store.state.serverAnswers;
    },
  },
  methods: {
    getTransferValue: function(): number {
      const transferValue = questions.getTransferValue();

      if (transferValue != null) {
        return transferValue;
      }

      const transferValueQuestionId = questions.transferValueAmountQuestion.id;
      const transferValueStoredAnswer: StoredAnswer = this.storedAnswers.filter(sa => sa.questionId == transferValueQuestionId)[0];
      return formatter.currencyToNumber(transferValueStoredAnswer.responses[0]);
    },
    getAdvisorDescription: function (advisor: Advisor): string[] {
      return this.showYesOutcome
        ? advisor.transferAdvisorDescription
        : advisor.generalAdvisorDescription;
    },
    shuffleArray: function (array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },
    getMoreDetailsResource(advisor: Advisor): string {
      if (advisor.moreDetails.startsWith("http")) {
        return advisor.moreDetails;
      }
      return 'content/advisors/' + advisor.moreDetails;
    }
  },
};
